import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrl: './our-services.component.scss'
})
export class OurServicesComponent implements OnInit, OnDestroy {

  private autoRotateInterval: any;
  selectedServiceIndex: number = 0;
  countUpOptions = { enableScrollSpy: true };
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }


  section3 = {
    badge: 'Sectores',
    title: 'Ramos de Operación',
    description: 'En Paredes y Asociados nos especializamos en proyectos de construcción de alta calidad, cuidando la seguridad, el bienestar de nuestros trabajadores y los intereses de nuestros clientes en cada etapa.'
  };

  services = [
    {
      title: 'Servicio de Salud',
      description: 'Trabajamos en la realización de varias centros de salud, clínicas, consultorios y hospitales.',
      image: '/assets/images/projects/habilitacion-hospital-tlaxiaco-oaxaca/48-habilitacion-hospital-tlaxiaco-oaxaca.webp',
      alt: 'Salud',
      icon: 'M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3ZM12 7C13.66 7 15 8.34 15 10C15 11.66 13.66 13 12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7ZM18 17H6V16C6 14.67 8.67 13.33 12 13.33C15.33 13.33 18 14.67 18 16V17Z',
      delay: '100'
    },
    {
      title: 'Industrial y Comercial',
      description: 'Colaboramos en proyectos "llave en mano" en fábricas de alimentos y laboratorios. así como de restaurantes, oficinas y tiendas para distintas cadenas',
      image: '/assets/images/projects/construccion-portal-conchal/107-construccion-portal-conchal.webp',
      alt: 'Industrial',
      icon: 'M19 3H5C3.9 3 3 3.9 3 5V8C3 9.1 3.9 10 5 10H6V13H5C3.9 13 3 13.9 3 15V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V15C21 13.9 20.1 13 19 13H18V10H19C20.1 10 21 9.1 21 8V5C21 3.9 20.1 3 19 3ZM8 13V10H16V13H8Z',
      delay: '200'
    },
    {
      title: 'Sector Público',
      description: 'Hemos formado parte en el importante desarrollo de varios proyectos de distintos Municipios.',
      image: '/assets/images/projects/remodelacion-oficinas-ine/8-remodelacion-oficinas-ine.webp',
      alt: 'Sector Público',
      icon: 'M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3ZM18.82 9L12 12.72L5.18 9L12 5.28L18.82 9ZM17 15.99L12 18.72L7 15.99V12.27L12 15L17 12.27V15.99Z',
      delay: '300'
    },
    {
      title: 'Vivienda',
      description: 'Hemos desarrollado mas de 1,000 viviedas y 30 desarrollos inmobiliarios.',
      image: '/assets/images/projects/construccion-5-casas-dif-oaxaca/22-construccion-5-casas-dif-oaxaca.webp',
      alt: 'Vivienda',
      icon: 'M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z',
      delay: '400'
    }
  ];

  centralImage = this.services[0].image;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.startAutoRotate();
    }
  }

  ngOnDestroy(): void {
    this.stopAutoRotate();
  }

  selectService(index: number): void {
    this.selectedServiceIndex = index;
    this.centralImage = this.services[index].image;
    this.restartAutoRotate();
  }

  private startAutoRotate(): void {
    this.autoRotateInterval = setInterval(() => {
      this.selectedServiceIndex = (this.selectedServiceIndex + 1) % this.services.length;
      this.centralImage = this.services[this.selectedServiceIndex].image;
    }, 5000);
  }

  private stopAutoRotate(): void {
    if (this.autoRotateInterval) {
      clearInterval(this.autoRotateInterval);
    }
  }

  private restartAutoRotate(): void {
    this.stopAutoRotate();
    this.startAutoRotate();
  }
}
